import { render, staticRenderFns } from "./SelectionBlockCategory.vue?vue&type=template&id=e0a8ab9a&scoped=true&"
import script from "./SelectionBlockCategory.vue?vue&type=script&lang=js&"
export * from "./SelectionBlockCategory.vue?vue&type=script&lang=js&"
import style0 from "./SelectionBlockCategory.vue?vue&type=style&index=0&id=e0a8ab9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a8ab9a",
  null
  
)

export default component.exports